import { UiRoutes } from '../lib/constants';

const PUBLIC_AUTH_ROUTES = [
  UiRoutes.LOGIN,
  UiRoutes.SIGNUP,
  UiRoutes.ADMIN_LOGIN,
  UiRoutes.LOGIN_OTP,
];

const getPathWithoutQuery = (pathname = ''): string =>
  pathname.split('?')[0].replace(/\/$/, '') || '/';

export const isPublicAuthRoute = (pathname = ''): boolean =>
  PUBLIC_AUTH_ROUTES.includes(getPathWithoutQuery(pathname));

export const getRefreshTokenPayloadForPath = (pathname = ''): {
  pathName: string;
  silentAuth: boolean;
} => {
  const pathWithoutQuery = getPathWithoutQuery(pathname);

  return {
    pathName: pathWithoutQuery.split('/')[1] || '',
    silentAuth: isPublicAuthRoute(pathWithoutQuery),
  };
};

export const shouldDeferRootRedirect = (
  pathname = '',
  loginState: { isLoading?: boolean; isWaitingForAPIResponse?: boolean } = {}
): boolean =>
  getPathWithoutQuery(pathname) === '/' &&
  Boolean(loginState.isWaitingForAPIResponse || loginState.isLoading);

export const getRootRedirectPath = (
  loginState: {
    isAdmin?: boolean;
    isPartnerMerchant?: boolean;
    isUserAuthenticated?: boolean;
    MerchantId?: number | string;
    selectedProduct?: { name?: string };
  } = {}
): string => {
  const {
    isAdmin,
    isPartnerMerchant,
    isUserAuthenticated,
    MerchantId,
    selectedProduct,
  } = loginState;

  if (!isUserAuthenticated) {
    return isAdmin ? UiRoutes.ADMIN_LOGIN : UiRoutes.LOGIN;
  }

  if (isPartnerMerchant) {
    return UiRoutes.PARTNER_SUMMARY;
  }

  if (selectedProduct?.name === 'EDGE') {
    return UiRoutes.EDGE_OVERVIEW;
  }

  if (selectedProduct?.name === 'PAYOUT') {
    return UiRoutes.INDIVIDUAL_PAYOUTS;
  }

  if (selectedProduct || (isAdmin && !MerchantId)) {
    return UiRoutes.OVERVIEW;
  }

  return isAdmin ? UiRoutes.ADMIN_LOGIN : UiRoutes.LOGIN;
};
